const filters = {
    quantityFilter: function (number) {
        if (number >= 100000) {
            return `${(number / 10000).toFixed(2)}万只`
        } else if (number > 0 && number < 100000) {
            return `${number}只`
        } else {
            return '--'
        }
    }
}


export default (vm) => {
  Object.keys(filters).forEach(key => {
    vm.filter(key, filters[key])
  })
}